export const SNIPPETS_ONBOARDING = {
	HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
	HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT: 'snippets:hasSeenSnippetsTabSpotlight',
} as const;

export const SnippetsOnboardingKeys = [...Object.values(SNIPPETS_ONBOARDING)] as const;
